"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/modal/index.ts
var modal_exports = {};
__export(modal_exports, {
  default: () => Modal_default
});
module.exports = __toCommonJS(modal_exports);
var import_index3 = require("./index.css");

// src/modal/Modal.tsx
var import_classnames6 = __toESM(require("classnames"));

// src/button/index.ts
var import_index = require("./index.css");

// src/button/Button.tsx
var import_react2 = require("react");

// src/button/_BaseButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react = require("react");

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/button/_baseButton.module.scss
var baseButton_module_default = {
  "heading-xxl": "_baseButton-module__heading-xxl___kwcRh",
  "heading-xl": "_baseButton-module__heading-xl___6zj6T",
  "heading-lg": "_baseButton-module__heading-lg___d7IqT",
  "heading-md": "_baseButton-module__heading-md___SmDLp",
  "heading-sm": "_baseButton-module__heading-sm___RUZyC",
  "heading-xs": "_baseButton-module__heading-xs___V91tJ",
  "body-one": "_baseButton-module__body-one___jiSyp",
  "body-two": "_baseButton-module__body-two___mLyhO",
  "body-three": "_baseButton-module__body-three___d5NIG",
  "body-four": "_baseButton-module__body-four___Kkh5r",
  "overline-one": "_baseButton-module__overline-one___v-7Xu",
  "overline-two": "_baseButton-module__overline-two___KG-wC",
  "overline-three": "_baseButton-module__overline-three___1RIPW",
  "strong": "_baseButton-module__strong___otOkq",
  "extra-strong": "_baseButton-module__extra-strong___dwGgk",
  "em": "_baseButton-module__em___cb8jk",
  "figcaption": "_baseButton-module__figcaption___7n9Wp",
  "no-margin": "_baseButton-module__no-margin___EHGgt",
  "button": "_baseButton-module__button___gGYwf",
  "buttonPendingWithHiddenText": "_baseButton-module__buttonPendingWithHiddenText___1W2Ul",
  "button-withForcedHover": "_baseButton-module__button-withForcedHover___tzWjJ",
  "button-primary": "_baseButton-module__button-primary___2ksGH",
  "button-purple": "_baseButton-module__button-purple___31oil",
  "button-black": "_baseButton-module__button-black___rgoFL",
  "button-white": "_baseButton-module__button-white___1kMMR",
  "button-destructive": "_baseButton-module__button-destructive___2OpdN",
  "button-secondary": "_baseButton-module__button-secondary___BpcuR",
  "button-gray": "_baseButton-module__button-gray___JxYvC",
  "button-tertiary": "_baseButton-module__button-tertiary___MMZKG",
  "button-l": "_baseButton-module__button-l___RV0rB",
  "button-iconOnly": "_baseButton-module__button-iconOnly___zWjVA",
  "button-m": "_baseButton-module__button-m___1eKjJ",
  "button-s": "_baseButton-module__button-s___WsV-p",
  "button-xs": "_baseButton-module__button-xs___VnYav"
};

// src/button/_BaseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var checkButtonPropsForErrors = ({
  icon,
  useAsLink,
  onClick,
  href,
  download,
  text,
  isIconOnly,
  color,
  type
}) => {
  if (color === "gray" && type == "primary" || color === "gray" && type === "tertiary" && !isIconOnly) {
    throw new Error(
      "Expect type prop to be secondary or tertiary(with isIconOnly prop set to true) when color is gray"
    );
  }
  if (color === "purple" && type === "secondary") {
    console.warn(
      "Warning: Button - Secondary Purple color is now deprecated. Please use different color or type. Secondary purple combination will be removed very soon."
    );
  }
  if (useAsLink) {
    if (!href) {
      throw new Error("Expect href prop when useAsLink is true");
    }
    if (onClick) {
      throw new Error(
        "Expect onClick prop to be undefined when useAsLink is true"
      );
    }
  }
  if (!useAsLink) {
    if (!onClick) {
      throw new Error("Expect onClick prop when useAsLink is false");
    }
    if (href) {
      throw new Error(
        "Expect href prop to be undefined when useAsLink is false"
      );
    }
    if (download) {
      throw new Error(
        "Expect download prop to be undefined when useAsLink is false"
      );
    }
  }
  if (isIconOnly) {
    if (!icon) {
      throw new Error("Expect icon prop when isIconOnly is true");
    }
    if (text) {
      throw new Error(
        "Expect text prop to be undefined when isIconOnly is true"
      );
    }
  }
  if (!isIconOnly) {
    if (icon) {
      throw new Error(
        "Expect icon prop to be undefined when isIconOnly is false"
      );
    }
    if (!text) {
      throw new Error("Expect text prop when isIconOnly is false");
    }
  }
};
var spinnerIcon = {
  iconName: "spinner",
  iconStyle: "solid",
  animationType: "spin"
};
var BaseButton = ({
  className,
  id,
  disabled = false,
  isPending = false,
  ariaLabel,
  size = "m",
  type = "primary",
  color = "purple",
  buttonTagTypeAttribute = "button",
  /** Text button specific props */
  iconLeft,
  iconRight,
  text,
  /** IconOnly button specific props*/
  isIconOnly = false,
  icon,
  /** <a> specific props */
  useAsLink = false,
  href,
  target,
  download,
  title,
  analyticsCallback,
  /** <button> specific props */
  onClick,
  value,
  name,
  forceHover = false,
  ...rest
}) => {
  const ButtonTag = useAsLink ? "a" : "button";
  const tagSpecificProps = ButtonTag === "a" ? {
    href: disabled ? void 0 : href,
    target,
    /** Copied from old button component. Only need it for the older browsers,
     *  since modern browsers (~2020+ release year secures these vulnerabilities by default) */
    // Opening links in new tabs with 'target=_blank' is inherently insecure. Unfortunately, we depend
    // on this functionality in a couple of place. Fortunately, it is possible to partially mitigate some of
    // the insecurity of this functionality by using the `rel` tag to block some of the potential exploits.
    // Therefore, we do so here.
    rel: target === "_blank" ? "noopener noreferrer" : void 0,
    download,
    title,
    onClick: analyticsCallback
  } : { type: buttonTagTypeAttribute, onClick, value, name };
  (0, import_react.useMemo)(
    () => checkButtonPropsForErrors({
      type,
      icon,
      useAsLink,
      onClick,
      href,
      download,
      text,
      isIconOnly,
      color
    }),
    [type, icon, useAsLink, onClick, href, download, text, isIconOnly, color]
  );
  const showIcon = icon && !isPending;
  const showIconLeft = iconLeft && !isPending;
  const showIconRight = iconRight && !isPending || isPending && iconRight && iconLeft;
  const addPendingButtonWithHiddenTextClass = isPending && !icon && !iconLeft && !iconRight;
  const spinnerPosition = iconRight && !iconLeft ? "right" : "left";
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
    ButtonTag,
    {
      className: (0, import_classnames2.default)(
        baseButton_module_default.button,
        baseButton_module_default[`button-${type}`],
        baseButton_module_default[`button-${color}`],
        baseButton_module_default[`button-${size}`],
        forceHover && baseButton_module_default["button-withForcedHover"],
        isIconOnly && baseButton_module_default["button-iconOnly"],
        addPendingButtonWithHiddenTextClass && baseButton_module_default.buttonPendingWithHiddenText,
        className
      ),
      id,
      disabled,
      ...rest,
      "aria-disabled": disabled || rest["aria-disabled"],
      "aria-label": ariaLabel || rest["aria-label"],
      ...tagSpecificProps,
      children: [
        isPending && spinnerPosition === "left" && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon }),
        showIconLeft && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
        showIcon && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...icon }),
        text && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: text }),
        showIconRight && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...iconRight }),
        isPending && spinnerPosition === "right" && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon })
      ]
    }
  );
};
var BaseButton_default = (0, import_react.memo)(BaseButton);

// src/button/Button.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Button = (props) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(BaseButton_default, { ...props });
var Button_default = (0, import_react2.memo)(Button);

// src/dialog/CustomDialog.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react7 = require("react");

// src/closeButton/index.ts
var import_index2 = require("./index.css");

// src/closeButton/CloseButton.tsx
var import_classnames3 = __toESM(require("classnames"));

// src/closeButton/closeButton.module.scss
var closeButton_module_default = {
  "closeButton": "closeButton-module__closeButton___Ab4hh",
  "closeButton-dark": "closeButton-module__closeButton-dark___RqPRh",
  "closeButton-light": "closeButton-module__closeButton-light___UBkFK",
  "closeButton-l": "closeButton-module__closeButton-l___Gw8DM",
  "closeButton-m": "closeButton-module__closeButton-m___11tsA",
  "closeButton-s": "closeButton-module__closeButton-s___4zy5d",
  "closeButton-xs": "closeButton-module__closeButton-xs___bjImb"
};

// src/closeButton/CloseButton.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var CloseButton = ({
  onClick,
  size = "m",
  "aria-label": ariaLabel,
  color = "dark",
  id,
  className,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
  "button",
  {
    type: "button",
    id,
    "aria-label": ariaLabel,
    className: (0, import_classnames3.default)(
      closeButton_module_default.closeButton,
      closeButton_module_default[`closeButton-${color}`],
      closeButton_module_default[`closeButton-${size}`],
      className
    ),
    onClick,
    ...HTMLAttributes3,
    children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FontAwesomeV6Icon_default, { iconName: "close" })
  }
);
var CloseButton_default = CloseButton;

// src/common/hooks/useBodyScrollLock.ts
var import_react3 = require("react");
var useBodyScrollLock = (isActive) => {
  (0, import_react3.useEffect)(() => {
    if (isActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isActive]);
};
var useBodyScrollLock_default = useBodyScrollLock;

// src/common/hooks/useEscapeKeyHandler.ts
var import_react5 = require("react");

// src/common/hooks/useDocumentKeydown.ts
var import_react4 = require("react");
var useDocumentKeydown = (callback) => {
  (0, import_react4.useEffect)(() => {
    if (callback) {
      document.addEventListener("keydown", callback);
    }
    return () => {
      if (callback) {
        document.removeEventListener("keydown", callback);
      }
    };
  }, [callback]);
};
var useDocumentKeydown_default = useDocumentKeydown;

// src/common/hooks/useEscapeKeyHandler.ts
var useEscapeKeyHandler = (callback) => {
  const handleKeyDown = (0, import_react5.useCallback)(
    (event) => {
      if (event.key === "Escape" && callback) {
        callback();
      }
    },
    [callback]
  );
  useDocumentKeydown_default(callback && handleKeyDown);
};
var useEscapeKeyHandler_default = useEscapeKeyHandler;

// src/common/hooks/useFocusTrap.ts
var import_react6 = require("react");
var useFocusTrap = (containerRef) => {
  const previouslyFocusedElement = (0, import_react6.useRef)(null);
  (0, import_react6.useEffect)(() => {
    if (containerRef.current) {
      previouslyFocusedElement.current = document.activeElement;
      const focusableElements = containerRef.current.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      firstElement == null ? void 0 : firstElement.focus();
    }
    return () => {
      if (previouslyFocusedElement.current) {
        previouslyFocusedElement.current.focus();
      }
    };
  }, [containerRef]);
  (0, import_react6.useEffect)(() => {
    const handleKeyDown = (event) => {
      if (event.key !== "Tab" || !containerRef.current) return;
      const focusableElements = containerRef.current.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      );
      const focusable = Array.from(focusableElements);
      const firstElement = focusable[0];
      const lastElement = focusable[focusable.length - 1];
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          event.preventDefault();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [containerRef]);
};
var useFocusTrap_default = useFocusTrap;

// src/dialog/customDialog.module.scss
var customDialog_module_default = {
  "customDialogOverlay": "customDialog-module__customDialogOverlay___lEzAp",
  "customDialog": "customDialog-module__customDialog___XCRm0",
  "customDialogCloseButton": "customDialog-module__customDialogCloseButton___cxCv5",
  "customDialog-light": "customDialog-module__customDialog-light___SOB0k",
  "customDialog-dark": "customDialog-module__customDialog-dark___fUKYs"
};

// src/dialog/CustomDialog.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var CustomDialog = ({
  mode = "light",
  className,
  onClose,
  closeLabel = "Close dialog",
  zIndex,
  children,
  ["aria-label"]: ariaLabel,
  ["aria-labelledby"]: ariaLabelledBy,
  ...HTMLAttributes3
}) => {
  const dialogRef = (0, import_react7.useRef)(null);
  useBodyScrollLock_default(true);
  useFocusTrap_default(dialogRef);
  useEscapeKeyHandler_default(onClose);
  (0, import_react7.useEffect)(() => {
    var _a;
    const hasDescriptionId = (_a = dialogRef.current) == null ? void 0 : _a.querySelector(
      "#dsco-dialog-description"
    );
    if (!hasDescriptionId) {
      console.warn(
        "Warning: CustomDialog component and it's derivatives (Dialog, Modal components) should have an element with id='dsco-dialog-description' to provide a description of dialog for screen readers."
      );
    }
  }, []);
  (0, import_react7.useEffect)(() => {
    if (!ariaLabel && !ariaLabelledBy) {
      console.warn(
        "Warning: CustomDialog component and it's derivatives (Dialog, Modal components) should have an aria-label or aria-labelledby attribute."
      );
    }
  }, [ariaLabel, ariaLabelledBy]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    "div",
    {
      role: "presentation",
      className: customDialog_module_default.customDialogOverlay,
      style: zIndex ? { zIndex } : {},
      children: /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
        "div",
        {
          role: "dialog",
          ref: dialogRef,
          "aria-modal": true,
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": "dsco-dialog-description",
          className: (0, import_classnames4.default)(
            customDialog_module_default.customDialog,
            customDialog_module_default[`customDialog-${mode}`],
            className
          ),
          ...HTMLAttributes3,
          children: [
            children,
            onClose && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
              CloseButton_default,
              {
                "aria-label": closeLabel,
                onClick: onClose,
                color: mode === "light" ? "dark" : "light",
                size: "l",
                className: customDialog_module_default.customDialogCloseButton
              }
            )
          ]
        }
      )
    }
  );
};
var CustomDialog_default = CustomDialog;

// src/typography/Typography.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_react8 = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "extra-strong": "typography-module__extra-strong___9SBuV",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw",
  "no-margin": "typography-module__no-margin___dyDRA"
};

// src/typography/Typography.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  noMargin = false,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames5.default)(
        typography_module_default[visualAppearance],
        noMargin && typography_module_default["no-margin"],
        className
      ),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react8.memo)(Typography);

// src/typography/TypographyElements.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var typographyElementsToGenerate = [
  {
    displayName: "Heading1",
    semanticTag: "h1",
    defaultVisualAppearance: "heading-xxl"
  },
  {
    displayName: "Heading2",
    semanticTag: "h2",
    defaultVisualAppearance: "heading-xl"
  },
  {
    displayName: "Heading3",
    semanticTag: "h3",
    defaultVisualAppearance: "heading-lg"
  },
  {
    displayName: "Heading4",
    semanticTag: "h4",
    defaultVisualAppearance: "heading-md"
  },
  {
    displayName: "Heading5",
    semanticTag: "h5",
    defaultVisualAppearance: "heading-sm"
  },
  {
    displayName: "Heading6",
    semanticTag: "h6",
    defaultVisualAppearance: "heading-xs"
  },
  {
    displayName: "BodyOneText",
    semanticTag: "p",
    defaultVisualAppearance: "body-one"
  },
  {
    displayName: "BodyTwoText",
    semanticTag: "p",
    defaultVisualAppearance: "body-two"
  },
  {
    displayName: "BodyThreeText",
    semanticTag: "p",
    defaultVisualAppearance: "body-three"
  },
  {
    displayName: "BodyFourText",
    semanticTag: "p",
    defaultVisualAppearance: "body-four"
  },
  {
    displayName: "OverlineOneText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-one"
  },
  {
    displayName: "OverlineTwoText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-two"
  },
  {
    displayName: "OverlineThreeText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-three"
  },
  { displayName: "EmText", semanticTag: "em", defaultVisualAppearance: "em" },
  {
    displayName: "StrongText",
    semanticTag: "strong",
    defaultVisualAppearance: "strong"
  },
  {
    displayName: "ExtraStrongText",
    semanticTag: "strong",
    defaultVisualAppearance: "extra-strong"
  },
  {
    displayName: "Figcaption",
    semanticTag: "figcaption",
    defaultVisualAppearance: "figcaption"
  }
];
var generateComponents = (componentsToGenerate) => componentsToGenerate.reduce((acc, componentTemplateData) => {
  const { displayName, semanticTag, defaultVisualAppearance } = componentTemplateData;
  const TypographyElement = (componentProps) => {
    const { visualAppearance, children, className, style, id, noMargin } = componentProps;
    return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      Typography_default,
      {
        semanticTag,
        visualAppearance: visualAppearance || defaultVisualAppearance,
        noMargin,
        className,
        style,
        id,
        children
      }
    );
  };
  TypographyElement.displayName = displayName;
  return { ...acc, [displayName]: TypographyElement };
}, {});
var {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  BodyOneText,
  BodyTwoText,
  BodyThreeText,
  BodyFourText,
  OverlineOneText,
  OverlineTwoText,
  OverlineThreeText,
  EmText,
  StrongText,
  ExtraStrongText,
  Figcaption
} = generateComponents(typographyElementsToGenerate);

// src/modal/modal.module.scss
var modal_module_default = {
  "modal": "modal-module__modal___jQ6u9",
  "modalTitleSection": "modal-module__modalTitleSection___jj9zc",
  "modalContentSection": "modal-module__modalContentSection___H9c41",
  "modalContentSection-top-imagePlacement": "modal-module__modalContentSection-top-imagePlacement___sSA2W",
  "modalContentSection-inline-imagePlacement": "modal-module__modalContentSection-inline-imagePlacement___TomsQ",
  "modalDescription": "modal-module__modalDescription___MUZUG",
  "modalActionsSection": "modal-module__modalActionsSection___grej6",
  "modalCloseButton": "modal-module__modalCloseButton___C1EN3",
  "modal-light": "modal-module__modal-light___Z-bDG",
  "modal-dark": "modal-module__modal-dark___ylKeV"
};

// src/modal/Modal.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Modal = ({
  title,
  description,
  primaryButtonProps,
  secondaryButtonProps,
  mode = "light",
  className,
  customContent,
  customBottomContent,
  onClose,
  closeLabel = "Close modal",
  imageUrl,
  imageAlt,
  imagePlacement = "top",
  ...HTMLAttributes3
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
    CustomDialog_default,
    {
      role: "dialog",
      className: (0, import_classnames6.default)(
        modal_module_default.modal,
        modal_module_default[`modal-${mode}`],
        className
      ),
      onClose,
      closeLabel,
      "aria-label": title,
      ...HTMLAttributes3,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: modal_module_default.modalTitleSection, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Heading3, { children: title }) }),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("hr", {}),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
          "div",
          {
            className: (0, import_classnames6.default)(
              modal_module_default.modalContentSection,
              modal_module_default[`modalContentSection-${imagePlacement}-imagePlacement`]
            ),
            children: [
              imageUrl && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("img", { src: imageUrl, alt: imageAlt || "" }),
              description && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                BodyTwoText,
                {
                  id: "dsco-dialog-description",
                  className: modal_module_default.modalDescription,
                  children: description
                }
              ),
              customContent
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("hr", {}),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: modal_module_default.modalActionsSection, children: [
          secondaryButtonProps && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
            Button_default,
            {
              type: "secondary",
              color: mode === "light" ? "black" : "white",
              ...secondaryButtonProps
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
            Button_default,
            {
              type: "primary",
              color: mode === "light" ? "purple" : "white",
              ...primaryButtonProps
            }
          )
        ] }),
        customBottomContent
      ]
    }
  );
};
var Modal_default = Modal;
//# sourceMappingURL=index.js.map